import{styled as t}from"styled-components";const e=t.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(67, 67, 67, 0.3);
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;export{e as Backdrop};
